import AddAndEditStockCategoryPage from "../../../../features/admin/stock-categories/add-and-edit-stock-category-page/add-and-edit-stock-category-page";

export default function AddAndEditStockCategory({
  isEdit,
}: {
  isEdit: boolean;
}) {
  return <AddAndEditStockCategoryPage isEdit={isEdit} />;
}
